/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as VerificationRouteImport } from "./routes/verification"
import { Route as RenewalRouteImport } from "./routes/renewal"
import { Route as PrivacyRouteImport } from "./routes/privacy"
import { Route as DemoRequestRouteImport } from "./routes/demo-request"
import { Route as BiometricPolicyRouteImport } from "./routes/biometric-policy"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"

const VerificationRoute = VerificationRouteImport.update({
  id: "/verification",
  path: "/verification",
  getParentRoute: () => rootRouteImport,
} as any)
const RenewalRoute = RenewalRouteImport.update({
  id: "/renewal",
  path: "/renewal",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRequestRoute = DemoRequestRouteImport.update({
  id: "/demo-request",
  path: "/demo-request",
  getParentRoute: () => rootRouteImport,
} as any)
const BiometricPolicyRoute = BiometricPolicyRouteImport.update({
  id: "/biometric-policy",
  path: "/biometric-policy",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/biometric-policy": typeof BiometricPolicyRoute
  "/demo-request": typeof DemoRequestRoute
  "/privacy": typeof PrivacyRoute
  "/renewal": typeof RenewalRoute
  "/verification": typeof VerificationRoute
  "/auth/callback": typeof AuthCallbackRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/biometric-policy": typeof BiometricPolicyRoute
  "/demo-request": typeof DemoRequestRoute
  "/privacy": typeof PrivacyRoute
  "/renewal": typeof RenewalRoute
  "/verification": typeof VerificationRoute
  "/auth/callback": typeof AuthCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/biometric-policy": typeof BiometricPolicyRoute
  "/demo-request": typeof DemoRequestRoute
  "/privacy": typeof PrivacyRoute
  "/renewal": typeof RenewalRoute
  "/verification": typeof VerificationRoute
  "/auth/callback": typeof AuthCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/biometric-policy"
    | "/demo-request"
    | "/privacy"
    | "/renewal"
    | "/verification"
    | "/auth/callback"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/biometric-policy"
    | "/demo-request"
    | "/privacy"
    | "/renewal"
    | "/verification"
    | "/auth/callback"
  id:
    | "__root__"
    | "/"
    | "/biometric-policy"
    | "/demo-request"
    | "/privacy"
    | "/renewal"
    | "/verification"
    | "/auth/callback"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BiometricPolicyRoute: typeof BiometricPolicyRoute
  DemoRequestRoute: typeof DemoRequestRoute
  PrivacyRoute: typeof PrivacyRoute
  RenewalRoute: typeof RenewalRoute
  VerificationRoute: typeof VerificationRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/verification": {
      id: "/verification"
      path: "/verification"
      fullPath: "/verification"
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/renewal": {
      id: "/renewal"
      path: "/renewal"
      fullPath: "/renewal"
      preLoaderRoute: typeof RenewalRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy": {
      id: "/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/demo-request": {
      id: "/demo-request"
      path: "/demo-request"
      fullPath: "/demo-request"
      preLoaderRoute: typeof DemoRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/biometric-policy": {
      id: "/biometric-policy"
      path: "/biometric-policy"
      fullPath: "/biometric-policy"
      preLoaderRoute: typeof BiometricPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BiometricPolicyRoute: BiometricPolicyRoute,
  DemoRequestRoute: DemoRequestRoute,
  PrivacyRoute: PrivacyRoute,
  RenewalRoute: RenewalRoute,
  VerificationRoute: VerificationRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
